export default "__VITE_ASSET__d147d5e9__"